import { Injectable } from '@angular/core';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomDatePickerConfig extends NgbDatepickerConfig {
    minDate = { day: 1, month: 1, year: 1900 };
    maxDate = { day: 1, month: 1, year: 2100};
}
